import { IConstraintAreaTeamRig } from '../../interfaces/iconstraint-area-team-rig';
import { Scenario } from '../scenario';

export class ConstraintAreaTeamRigBase {
  ConstraintAreaTeamRigId: number;
  ScenarioId: number;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenario?: Scenario;

  constructor(item?: IConstraintAreaTeamRig) {
    if (item) {

      this.ConstraintAreaTeamRigId = item.ConstraintAreaTeamRigId;
      this.ScenarioId = item.ScenarioId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenario = new Scenario(item.Scenario);
    }
  }
}